import React from 'react';
import './WellDone.css';

const WellDone = (props) => {
	let lettersWell = {};	
	function wordsLetter()	{
		lettersWell = [];
		let countLetters = props.textGame.length;
		let posx = 350 - countLetters * 25;

		for (let i=0; i <  countLetters; i++) {
			lettersWell.push({
			letter: props.textGame[i],
			posX: posx + i*50,
			posY: 100
			});
		};
	};
	wordsLetter();
	
const wordsWellDone = lettersWell.map( items => {
	return (
		<span key = {items.posX} style = {{left: items.posX}} className = 'Letter' >{items.letter}</span>
	);	
});	

    return (
        <div>
            <img src={props.src} className='smallBg' alt = '' />
            <div  className = 'WellDoneSun' ></div>
				{wordsWellDone}
	        </div>
    );
    };

export default WellDone;
